import {
    rowModified,
    saveTask
} from "../ducks/task";

let timer = null;
const saveDelay = 3000;
const translationsToSave = {};

const saveHandler = store => next => action => {
    if (rowModified.match(action)) {
        translationsToSave[action.payload.taskID] = "";
        queueSave(store);
    } else if (saveTask.fulfilled.match(action)) {
        delete translationsToSave[action.payload.translationID];
    } else if (saveTask.rejected.match(action)) {
        queueSave(store);
    }
    return next(action);
};

function queueSave(store) {
    if (timer != null) clearInterval(timer);

    timer = setInterval(() => {
        Object.keys(translationsToSave).forEach(taskID => {
            store.dispatch(saveTask({taskID}));
        });

        clearInterval(timer);
    }, saveDelay);
}

export default saveHandler;